export const intersectObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) entry.target.classList.add('enterAnim');
    else entry.target.classList.remove('enterAnim');
  });
});
